<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Change Learner Transport Route</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
            <v-col cols="12" sm="3">
             <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
             <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"/>
            </v-col>
             <v-col cols="12" sm="4" md="4">
                <p><v-icon color="error">*</v-icon><b>Student</b></p>
                <v-autocomplete color="#0F2027" dense rounded required v-model="learner" :items="learner_list" item-text="name" item-value="lid" label="Student" outlined persistent-hint hint="Please Select Child" @change="getTransportDetails()"/>
          </v-col>
            </v-row>
       </v-card>
        <v-card class="box" v-if="apply_new_transport_card">
          <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Apply Student Transport</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
      </v-toolbar>
        <v-row justify="center" dense>
           <v-col cols="12" sm="1">
           </v-col>
          <v-col cols="12" sm="3">
            <v-btn color="warning" @click="applyNewTransport()">Select Appropriate Route</v-btn>
          </v-col>
        </v-row>
        </v-card>

        <v-card class="box" v-if="learner_transport_fees_list.length > 0">
    <v-toolbar flat dense class="toolbar">
    <v-toolbar-title>Learner Transport Details</v-toolbar-title>
    <v-divider class="mx-4" inset vertical></v-divider>
    <v-spacer></v-spacer>
      </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="12">
            <!-- <v-card class="box" > -->
            <v-simple-table dense class="elevation-1">
              <template>
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Route</th>
                    <th>Route Stop</th>
                    <th>Distance Slab In KM</th>
                    <th>Fees In Rs.</th>
                    <th>Change Bus Route</th>
                    <th>Apply For Installment</th>
                    <th>View Previous Installments</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, i) in learner_transport_fees_list" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.route }}</td>
                    <td>{{ item.routestop }}</td>
                    <td>{{ item.distanceslab }}</td>
                    <td>{{ item.totalfees }}</td>
                    <td><v-btn color="warning" @click="applyTransport()">Change</v-btn></td>
                    <td><v-btn color="warning" @click="applyTransportInstallment(item)">Apply</v-btn></td>
                    <td>
                      <span v-if="item.installment_present">
                      <v-avatar size="35"><v-icon class="mr-4 v-icon-size" color="red" @click="getInstallmentHistory(item)">mdi-eye</v-icon></v-avatar>
                      </span>
                      <span v-else>
                        --
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
           
          </v-col>
        </v-row>
      </v-card>
       <!-- {{learner_transport_fees_installment_list}} -->
      <v-card class="box" v-if="show_apply_transport_card == true" >
        <v-card>
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_apply_transport_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Change Transport Route </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="4" md="4">
                <p><v-icon color="error">*</v-icon><b>Route Stop</b></p>
                <v-autocomplete color="#0F2027" dense rounded required v-model="route_stop" @change="getRoutes()" :items="route_stops" item-text="name" item-value="id" label="Route Stop" outlined persistent-hint hint="Please Select Route Stop"/>
              </v-col>
              <!-- <v-col cols="12" sm="4"> </v-col> -->
            </v-row>

            <v-row justify="center" dense v-if="route_details_list.length > 0">
              <v-col cols="12" sm="12" md="12">
                <!-- <v-card class="box" > -->
                <v-simple-table dense class="elevation-1">
                  <template>
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Route</th>
                        <th>Distance Slab In KM</th>
                        <th>Fees In Rs.</th>
                        <th>Select Route</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(item, i) in route_details_list" :key="i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.route }}</td>
                        <td>{{ item.distance }}</td>
                        <td>{{ item.fees }}</td>
                        <td>
                          <input type="radio" name="selected_route" class="radiospace" v-model="selected_route" v-bind:value="item.id"/>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-row justify="center" class="pt-5" dense v-if="selected_route">
                  <!-- <v-col col="12" sm="6" md="6"> -->
                  <v-btn small color="warning" @click="SaveUpdateTransport()"
                    >Save</v-btn
                  >
                  <!-- </v-col> -->
                </v-row>

                <!-- </v-card> -->
              </v-col>
            </v-row>
          </v-card>
          <!-- </v-row> -->
        </v-card>
      </v-card>

        <v-dialog v-model="show_installment_history_card" max-width="1200px">
        <v-card class="card-container">
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_installment_history_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Student Transport Installments </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
           <v-card class="box">
            <v-data-table :headers="headers_installments" :items="learner_transport_fees_installment_list">
               <template v-slot:[`item.delete_installment`]="{ item }">
                   <div v-if="item.can_delete">
                      <v-btn color="warning" icon dark v-on="on" @click="deleteInstallment(item)" title="Delete Installment"><v-icon>mdi-delete-empty</v-icon></v-btn>
                   </div>
                   <div v-else>Cannot Delete As Payment Done...</div>
        </template>
            </v-data-table>
          </v-card>
        </v-card>
        </v-dialog>

          <v-card class="box" v-if="apply_payment_card" >
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Select Payment Method</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- <v-card class="box"> -->
        <v-row justify="center" dense v-if="all_transport_installments.length > 0">
          <span v-for="(inst, index) in this.all_transport_installments" :key="index">
            <input
              type="radio"
              class="radiospace"
              v-model="transport_installment"
              v-bind:value="inst"
              @change="setName(inst.id)"
            />
            {{ inst.name }}
          </span>
        </v-row>
        <v-row justify="center" dense v-if="show_fees">
          <p><b>Installment Fees In Rs.</b></p>
          {{ fees_applicable }}
        </v-row>
        <v-row justify="center" dense v-if="show_fees">
          <v-btn small color="warning" @click="SaveTransportInstallment()"
            >Save</v-btn
          >
        </v-row>
        <!-- </v-card> -->
      </v-card>

<!-- {{learner_transport_fees_installment_details}} -->
<!-- {{allow_approve_transport}} -->
      <v-card v-if="allow_approve_transport && learner_transport_fees_installment_details.length>0" class="box">
          <v-toolbar class="toolbar no-display" flat dense>
            <v-toolbar-title>
              <strong> Student Transport Installments list</strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
           <v-card class="box">
            <v-data-table :headers="headers_learner_installments" :items="learner_transport_fees_installment_details">
               <template v-slot:[`item.approve`]="{ item }">
                   <div v-if="item.can_modify_status">
                     <v-btn color="warning" @click="approveTransport(item)">Approve</v-btn>
                   </div>
                   <div v-else>Already Approved...</div>
        </template>
            </v-data-table>
          </v-card>
      </v-card>

        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      allow_approve_transport:false,
      learner_transport_fees_installment_details:[],
      show_fees:false,
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      ay_list:[],ay:"",learner_list:[],learner:"",learner_transport_fees_list:[],learner_transport_fees_installment_list:[],all_transport_installments:[],transport_installment:"",
      show_apply_transport_card: false,show_installment_history_card:false,apply_payment_card:false,learner_transport_fees_amount_id:"",fees_applicable:"",
      apply_new_transport_card: false,
      route_stops: [],
      route_stop: "",
      route_details_list: [],
      route_details: "",
      selected_route: null,learner_transport_fees_temp:"",
      headers_installments:[
      { text: "SR No", value: "srno" },
      { text: "Route Stop", value: "routestop" },
      { text: "Installment", value: "transportinstallment" },
      { text: "Amount To Pay", value: "amount_to_pay" },
      { text: "Amount Paid", value: "paid_till_now" },
      { text: "Delete Installment", value: "delete_installment" },
      //{ text: "Amount To Pay", value: "amount_to_pay" },
      ],
       headers_learner_installments:[
      { text: "SR No", value: "srno" },
      { text: "Route Stop", value: "route_stop" },
      { text: "Installment", value: "transportinstallment" },
      { text: "Amount To Pay", value: "amount" },
      { text: "Amount Paid", value: "paid_till_now" },
      { text: "Approve", value: "approve" },
      //{ text: "Amount To Pay", value: "amount_to_pay" },
      ],
  }),
   methods: {
    approveTransport(item){
 if (!confirm("Are You Sure You Want To Approve Request...?")) return;
      const data = {
        transportinstallment: item.id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/approveTransportRequest", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green","Approved Successfully...");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.getTransportDetails();
        });
    },
    deleteInstallment(item){
        if (!confirm("Are You Sure You Want To Delete..?"))
             return;
      const data = {
        learner_transport_fees_installment_id: item.learner_transport_fees_installment_id,
      };
      axios
        .post("ParentTransport/delete_learner_transport_fees_installment",data)
        .then((res) => {
          if (res.data.flag == "YES") {
             this.showSnackbar("red", res.data.snackbar);
            this.overlay = false;
            //this.getInstallmentHistory(this.learner_transport_fees_temp)
            this.show_installment_history_card=false
            this.learner_transport_fees_list =res.data.learner_transport_fees_list;
          } else if(res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
         // this.getInstallmentHistory(this.learner_transport_fees_temp)
        });  
    },
     SaveTransportInstallment() {
      if (!confirm("Are You Sure You Want To Apply...?")) return;
      const data = {
        academicYear: this.ay,
        learner: this.learner,
        learner_transport_fees_id: this.learner_transport_fees_amount_id,
        transport_installment: this.transport_installment.id,
        fees_applicable: this.fees_applicable,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/SaveLearnerTransportInstallment", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.transport_installments = res.data.transport_installments;
             this.learner_transport_fees_list =res.data.learner_transport_fees_list;
             this.learner_transport_fees_installment_details=res.data.learner_transport_fees_installment_details;
            this.apply_payment_card = false;
            this.showSnackbar("green", res.data.snackbar);
          } else if (res.data.flag == "No") { 
            this.apply_payment_card = false;
            this.showSnackbar("red", res.data.snackbar);
             this.learner_transport_fees_list =res.data.learner_transport_fees_list;
          }
          else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.transport_installment="",this.fees_applicable="",this.show_fees=false
          this.overlay = false;
        });
    },
    setName(installment_name) {
      const data = {
        installment:installment_name,
        learner_transport_fees_amount_id:this.learner_transport_fees_amount_id
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentAmount", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fees_applicable=res.data.final_amount
            this.show_fees = true
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    applyTransportInstallment(item){
      this.learner_transport_fees_amount_id=item.id
      this.getInstallmentDetails()
      this.apply_payment_card=true
      // alert(JSON.stringify(this.all_transport_installments))
    },
     getInstallmentHistory(item){
      this.learner_transport_fees_installment_list=item.learner_transport_fees_installment_details
      this.show_installment_history_card=true
      this.learner_transport_fees_temp=item
     },
     SaveUpdateTransport() {
      if (!confirm("Are You Sure You Want To Apply...?")) return;
      const data = {
        academicYear: this.ay,
        selected_route: this.selected_route,
        learner: this.learner,
        route_stop:this.route_stop
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/SaveUpdateTransport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", res.data.snackbar);
            this.learner_transport_fees_list =res.data.learner_transport_fees_list;
            this.show_apply_transport_card = false;
            this.selected_route="",this.route_stop="",this.route_details_list=[]
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.apply_new_transport_card = false;
        });
    },
     getRoutes() {
      const data = {
        ay:this.ay,
        route_stop: this.route_stop,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getRoutes", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.route_details_list = res.data.route_details_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    applyNewTransport() {
     //this.apply_new_transport_card = true;      
     this.show_apply_transport_card = true;
      this.selected_route="",this.route_stop="",this.route_details_list=[]
    },
    applyTransport() {
      this.show_apply_transport_card = true;
      this.selected_route="",this.route_stop="",this.route_details_list=[]
    },
    getTransportDetails(){
      this.show_apply_transport_card = false;
      this.selected_route="",this.route_stop="",this.route_details_list=[]
      const data = {
        ay: this.ay,
        learner: this.learner,
      };
      axios
        .post("ParentTransport/getLearnerTransportDetails",data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.learner_transport_fees_installment_details=res.data.learner_transport_fees_installment_details;
            this.learner_transport_fees_list =res.data.learner_transport_fees_list;
            this.route_stops = res.data.route_stops;
            this.all_transport_installments = res.data.transport_installments;
            this.allow_approve_transport = res.data.Allow_Approve_Transport;
            this.overlay = false;
          } else if(res.data.flag == "No") {
            this.learner_transport_fees_list =[];
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.route_stops = res.data.route_stops;
            if(res.data.is_blocked_for_transport == true){
              this.apply_new_transport_card = false; 
            }else{
            this.apply_new_transport_card = true; 
            }
            this.overlay = false;
          }
        })
        .catch((error) => {
         // this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.learner_transport_fees_amount_id=""
          this.apply_payment_card=false
        });  
    },
    getInstallmentDetails(){
      // this.show_apply_transport_card = false;
      // this.selected_route="",this.route_stop="",this.route_details_list=[]
      const data = {
        ay: this.ay,
        learner: this.learner,
      };
      axios
        .post("ParentTransport/getLearnerTransportDetails",data)
        .then((res) => {
          if (res.data.flag == "YES") {           
            this.all_transport_installments = res.data.transport_installments;
            this.overlay = false;
          } else if(res.data.flag == "No") {
            // this.learner_transport_fees_list =[];
            this.showSnackbar("red", res.data.snackbar);
            // sessionStorage.setItem("error-trace", res.data.error_trace);
            // this.route_stops = res.data.route_stops;
            // if(res.data.is_blocked_for_transport == true){
            //   this.apply_new_transport_card = false; 
            // }else{
            // this.apply_new_transport_card = true; 
            // }
            this.overlay = false;
          }
        })
        .catch((error) => {
         // this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          // this.overlay = false;
          // this.learner_transport_fees_amount_id=""
          // this.apply_payment_card=false
        });  
    },
     onLoad() {
      axios
        .post("ParentTransport/changeLearnerTransportRoute")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.learner_list = res.data.learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
sub-row {
  border: 2px solid #424093;
  margin: 1rem;
  border-radius: 5px;
}

i {
  font-size: 20px !important;
}

.v-card__title {
  border: 1px solid #80808040;
  font-weight: bold;
  background-color: #424093;
  color: white;
  text-align: center;
  /* margin-top: 1.5rem; */
}
.card-border {
  border: 2px solid darkblue;
  border-radius: 10px;
  /* padding: 5px; */
  /* margin: 1rem !important; */
  width: auto;
}

.tx-bold {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

i {
  font-size: 26px;
  cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #424093 !important;
  color: white !important;
  margin-top: 2.35rem;
  border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {
}

.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}

v-simple-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: auto;
  border: 1px solid #ddd;
}

th {
  color: white;
  font-weight: bold;
  text-align: center !important;
}

td,
th {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: center;
}
@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}

@media all and (min-width: 1000px) {
  .padding-metting {
    padding-right: 22px;
  }
}
@media (min-width: 320px) and (max-width: 350px) {
  .padding-bot {
    font-size: 11.6px;
  }
}
@media (min-width: 1000px) and (max-width: 1050px) {
  .padding-bot {
    font-size: 9.6px;
  }
}
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
 .card-container {
        overflow-x: hidden;
        overflow: hidden;
    }
</style>